<template>
  <!-- 设备列表 -->
 <modal :title="$t('labelTitle.Device')" :visible.sync="isShowDialog" width="500px" append-to-body @close="close">
    <div class="uk-flex ml-5 mt-5">
        <el-select v-model="tableModel.code" @change="deviceTypeChange">
            <el-option v-for="item in deviceTypeList" :key="item.code" :label="`${$t(deviceTypeListConvert[item.code])}`"
                :value="item.code"></el-option>
        </el-select>
        <el-input class="ml-5" v-model="tableModel.deviceCode" style="width:150px;"
            :placeholder="$t('integration.equipment_no')"></el-input>
        <div class="ml-5">
            <el-button type="primary" icon="el-icon-search" @click="seaechList"></el-button>
            <el-button icon="el-icon-refresh" @click="resetCondition"></el-button>
        </div>
    </div>
    
    <div class="device-div" ref="deviceDiv"
        v-infinite-scroll="loadmoreList"
        infinite-scroll-disabled="scrollDisabled">
      <el-table  :data="deviceList" :show-header="false" >
        <el-table-column width="150px">
          <template #default="{ row, $index }">
            <div class="name-div">
              <div class="code-div" :class="{red: !row.deviceStatus,
                'bg-gray': row.carrierName, 
                'bg-theme': !row.carrierName,
                'bg-orange': selDeviceList.some(_ => _.change_device_id === row.id)}">{{ row.deviceCode }}</div>
              <el-row>
                <el-col :span="7">
                  <el-checkbox v-model="checkbox[$index]"
                      @change="handleChangeDevice(row, $index)"></el-checkbox>
                </el-col>
                <el-col :span="7">
                  <i v-if="row.calibrationType && Date.now() > row.calibrationExpireTime"
                    class="iconfont icon-jinzhi icon" style="color: orange">
                  </i>
                  <i v-else class="iconfont icon-mubiao icon"
                    :style="{color: row.calibrationType !== undefined ? '#70b700' : '#aaa'}">
                  </i>
                </el-col>
                <el-col :span="10">{{ $t(equiStatusConvert(row.deviceStatus).title) }}</el-col>
              </el-row>
            </div>
          </template>
        </el-table-column>
          <el-table-column width="250px"  :label="$t('integration.monitoring_point')" prop="carrierName"
            show-overflow-tooltip>
            <template #default="{row}">
                <CardSwipper v-if="row.carrierName" :key="Math.random()" :list="row.carrierList" bgColor="bg-gray">
                    <template #title='{item}'>
                      {{ item.scene }}
                    </template>
                  <template #default='{item}'>
                    {{ item.carrierName }}
                  </template>
                </CardSwipper>
                <div v-else class="no-tips">{{ $t('public.no_monitoring_points')}}</div>
            </template>
        </el-table-column>
      </el-table>
      <p v-if="loading" style="text-align: center; padding: 10px;">{{ $t('text.Loading') }}</p>
      <p v-if="noMore" style="text-align: center; padding: 10px;">{{ $t('public.no_more') }}</p>
    </div>

    <div slot="footer">
        <el-button type="primary" @click="close">{{ $t('public.btn_close') }}</el-button>
        <el-button type="primary" @click="apply">{{ $t('public.btn_confirm') }}</el-button>
      </div>
 </modal>
</template>
<script>
import {getDevicePage } from '@/api/modules/carrier'
import { getDeviceType } from '@/api/modules/public'
import { equiStatusConvert, deviceTypeListConvert } from '@/utils/convert'
import CardSwipper from '@/components/CardSwipper/CardSwipper.vue'
import { getTaskDevice }  from '@/api/modules/verification'

export default {
  name: 'DeviceList',
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    // 已添加的验证设备list
    selDeviceList: {
      type: Array,
      default: () => []
    },
    sceneId: {
      type: Number|String,
      default: 1
    },
    structureId: {
      type: Number |String,
      default: ''
    }
  },
  components: {
    CardSwipper,
  },
  data() {
    return {
      deviceList: [],
      tableModel: {
        iDisplayStart: 0,
        iDisplayLength: 10,
        sceneId: this.sceneId,
        structureId: this.structureId,
        deviceCatalog: 0,
        deviceCode: '',
        code: 'zbp_1',
        deviceType: 1
      },
      loading: false,
      total: 0,
      selectDevice: null,
      deviceTypeList: [],
      checkbox: [],
      dioForm: {
        name: '',
      },
      rules: {
        name: [
          { required: true, message: this.$t('public.verify_device_title') + this.$t('integration.cannot_be_empty'), trigger: 'blur' }
        ],
      },
    }
  },
  computed: {
    isShowDialog: {
      get: function () {
        return this.isShow
      },
      set: function (val) {
        this.$emit('update:isShow', val) // 可以优化成model  或者minx
      }
    },
    equiStatusConvert: () => equiStatusConvert,
    noMore() {
      return this.deviceList.length >= this.total
    },
    scrollDisabled(){
      return this.loading || this.noMore
    },
    deviceTypeListConvert: () => deviceTypeListConvert,
  },
  mounted(){
    this.getDeviceType().then(() => {
      this.getListFn()
    })
  },
  methods: {
    // 由于可能是一个设备对应多个监测点 需要对监测点进行预处理
    carrierPreHandle (row) {
      if (!row.carrierId) { return [] }

      const info = []
      const carrierIds = row.carrierId.split(',')
      const carrierNames = row.carrierName.split(',')
      const scenes = row.structureName.split(',')
      carrierIds.forEach((id, index) => {
        info.push({
          id,
          carrierName: carrierNames[index],
          scene: scenes[index]
        })
      })
      return info
    },
    getListFn (next = false) {
      this.loading = true
      // getTaskDevice(this.tableModel)
      getDevicePage(1, this.tableModel)
        .then(res => {
          const { pageInfo, result } = res.result
          this.total = pageInfo.total
          let curDeviceList = next ? this.deviceList : []
          let list = result.map(row => {
            row.carrierList = this.carrierPreHandle(row)
            return row
          })
          this.deviceList = curDeviceList.concat(list)
        })
        .finally(() => {
          if(this.isShowDialog){
            this.$refs.deviceDiv.scrollTop = this.$refs.deviceDiv.scrollTop - 5
          }
          this.loading = false
        })
    },
    getDeviceType () {
      return new Promise(resolve => {
        getDeviceType().then(({ result }) => {
          this.deviceTypeList = result
          if (result.length) {
            this.tableModel.code = result[0].code
            this.tableModel.deviceType = result[0].id
            // this.tableModel.deviceCatalog = parseInt(result[0].deviceCatalog)
          }
          resolve()
        })
      })
    },
    deviceTypeChange (code) {
      const device = this.deviceTypeList.find(item => item.code === code)

      if (device) {
        this.tableModel.deviceType = device.id
        this.tableModel.deviceCatalog = parseInt(device.deviceCatalog)
        this.seaechList()
      }
    },
    resetCondition () {
      this.tableModel.deviceCode = ''
      this.seaechList()
    },
    seaechList(){
      this.tableModel.iDisplayStart = 0
      this.deviceList = []
      this.getListFn()
    },
    // 选择设备
    handleChangeDevice (device, index) {
      this.selectDevice = { ...device }
      this.checkbox = this.checkbox.map(() => false)
      this.checkbox[index] = true
      this.$forceUpdate()
    },
    apply(){
      if(!this.selectDevice){
          this.$message.warning($t('integration.please_select_device'))
          return
      }
      // 重复设备校验
      let index = this.selDeviceList.findIndex(_ => _.id === this.selectDevice.id)
      if(index !== -1){
        this.$message.warning($t('integration.this_device_already_exists'))
        return
      }

      this.$emit('updateDevice', {
        ...this.selectDevice
      })
      this.close()
    },
    close(){
      this.$emit('close')
      this.dioForm.name = ''
      this.selectDevice = null
      this.checkbox = this.checkbox.map(() => false)
    },
    // 设备列表滚动加载下一页
    loadmoreList(){
      console.log('-loadmoreList------------')
      this.tableModel.iDisplayStart ++ 
      this.getListFn(true)
    },
  }
}
</script>
<style lang="scss" scoped>
.device-div {
  // width: 450px;
  height: 400px;
  overflow: scroll;
  .no-tips {
    width: 100%;
    height: 50px;
    border: 1px solid #AAAAAA;
    text-align: center;
    align-content: center;
  }
  .name-div {
    border: 1px solid #AAAAAA;
  }
  .code-div {
    border-bottom: 1px solid #AAAAAA;
    text-align: center;
    &.red {
      color: red;
    }
  }
  ::v-deep .el-col {
    text-align: center;
    border-right: 1px solid #AAAAAA;
    &:last-child {
      border-right: none;
    }
  }
  ::v-deep .el-table__cell {
    padding: 8px 2px !important;
  }
}

</style>